import React from "react";
import { Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HandshakeIcon from "@mui/icons-material/Handshake";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import NotesIcon from "@mui/icons-material/Notes";

const Line = ({ icon, value }) =>
  value ? (
    <Typography
      variant="subtitle1"
      color="text.secondary"
      sx={{ display: "flex", alignItems: "center", mt: 1 }}
    >
      {icon}
      &nbsp;
      {value}
    </Typography>
  ) : null;

export const CardReference = ({ reference }) => {
  return (
    <Card
      sx={{
        display: "flex",
        boxShadow: "1px 4px 10px rgba(0,0,0,.15)",
        borderRadius: 3,
        width: "100%",
        height: "100%",
      }}
    >
      <CardContent sx={{ flex: "1 0 auto", width: "100%" }}>
        <Typography
          component="div"
          variant="h6"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <PersonIcon color={"primary"} />
          &nbsp;
          {reference?.name}
        </Typography>
        <Line icon={<WorkIcon />} value={reference?.position} />
        <Line icon={<ApartmentIcon />} value={reference?.company} />
        <Line icon={<HandshakeIcon />} value={reference?.relationship} />
        <Line icon={<EmailIcon />} value={reference?.email} />
        <Line icon={<LocalPhoneIcon />} value={reference?.phone} />
        <Line icon={<NotesIcon />} value={reference?.notes} />
      </CardContent>
    </Card>
  );
};
